import { useState, useEffect } from 'react';

/**
 * Returns true if Cashier Secret Key verification is required for discounts / sensitive operations.
 * Defaults to false (Disabled by default). Can be enabled in POS Admin Settings.
 */
export const isCashierSecretKeyEnabled = () => {
    try {
        const cached = localStorage.getItem('enable_cashier_secret_key');
        return cached === 'true'; // Defaults to false if not set
    } catch (e) {
        return false;
    }
};

/**
 * Hook providing reactive access to the Cashier Secret Key enabled state.
 * Listens for local updates and cross-tab storage changes.
 */
export const useCashierSecretKeySetting = () => {
    const [enableSecretKey, setEnableSecretKey] = useState(isCashierSecretKeyEnabled());

    useEffect(() => {
        const handleStorageChange = () => {
            setEnableSecretKey(isCashierSecretKeyEnabled());
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('secret_key_setting_changed', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('secret_key_setting_changed', handleStorageChange);
        };
    }, []);

    const updateSecretKeySetting = (enabled) => {
        const strVal = enabled ? 'true' : 'false';
        localStorage.setItem('enable_cashier_secret_key', strVal);
        setEnableSecretKey(enabled);
        window.dispatchEvent(new Event('secret_key_setting_changed'));
        window.dispatchEvent(new Event('storage'));
    };

    return { enableSecretKey, updateSecretKeySetting };
};

export default useCashierSecretKeySetting;
